import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import homeDefaultCategories from '../../../utils/User/constants/home/homeCategories'

const CategoryCard = () => (
  <>
    {
        homeDefaultCategories?.map((category) => {
          const {
            id, link, image, label,
          } = category
          return (
            <Link
              id={ id }
              key={ id }
              className='col-md-3 m-4 jumbotron cd-1 borderRadius'
              to={ link }
            >
              {/* <Link > */}
              <h3 className='whiteText text-center justify-content-center font-weight-bold'>{ label }</h3>
              <div className='text-center'>
                <button
                  type='button'
                  className='btn btn-outline-light text-center justify-content-center'
                >
                  Click Here
                </button>
              </div>
              {/* </Link> */}
            </Link>
          )
        })
    }
  </>
)

export default memo(CategoryCard)
